import { useMutation }          from '@tanstack/react-query'
import { notificationService }  from '@services'
import { queryClient }          from '@providers/QueryProvider'
import { QUERY_KEYS }           from '@constants/queryKeys'
import { useAuthStore }         from '@store'

function invalidateAll() {
  queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications.all() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notificationHistory.all() })
}

/**
 * useCreateNotificationMutation — admin: send a new notification.
 */
export function useCreateNotificationMutation() {
  return useMutation({
    mutationFn: (data) => notificationService.create(data),
    onSuccess:  invalidateAll,
  })
}

/**
 * useMarkReadMutation — mark a single notification as read.
 */
export function useMarkReadMutation() {
  const user   = useAuthStore((s) => s.user)
  const userId = user?.id ?? 'guest'

  return useMutation({
    mutationFn: (id) => notificationService.markRead(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications.mine(userId) })
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications.unread(userId) })
    },
  })
}

/**
 * useMarkAllReadMutation — mark all notifications as read for the current user.
 */
export function useMarkAllReadMutation() {
  const user   = useAuthStore((s) => s.user)
  const userId = user?.id ?? 'guest'

  return useMutation({
    mutationFn: () => notificationService.markAllRead(userId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications.mine(userId) })
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.notifications.unread(userId) })
    },
  })
}

/**
 * useDeleteNotificationMutation — delete a notification.
 */
export function useDeleteNotificationMutation() {
  return useMutation({
    mutationFn: (id) => notificationService.remove(id),
    onSuccess:  invalidateAll,
  })
}
